import type { CreateTicketPayload, SlaPriorityCode } from '../types';

type LegacyTicketPriority = NonNullable<CreateTicketPayload['priority']>;

export type CategoryPriorityLabel =
  | 'critical'
  | 'high'
  | 'medium'
  | 'low'
  | 'scheduled';

export type CategoryPrioritySelection = {
  priorityCode: SlaPriorityCode;
  priorityLabel: CategoryPriorityLabel;
};

export type CategoryPriorityUser = {
  id?: unknown;
  tenantSetting?: {
    categoryPriorityMappingEnabled?: boolean;
  } | null;
  parent?: {
    tenantSetting?: {
      categoryPriorityMappingEnabled?: boolean;
    } | null;
  } | null;
};

export const CATEGORY_PRIORITY_OPTIONS: ReadonlyArray<{
  value: SlaPriorityCode;
  label: string;
  priorityLabel: CategoryPriorityLabel;
}> = [
  { value: 'P1', label: 'P1 - Critical', priorityLabel: 'critical' },
  { value: 'P2', label: 'P2 - High', priorityLabel: 'high' },
  { value: 'P3', label: 'P3 - Medium', priorityLabel: 'medium' },
  { value: 'P4', label: 'P4 - Low', priorityLabel: 'low' },
  { value: 'P5', label: 'P5 - Scheduled', priorityLabel: 'scheduled' },
];

export const isCategoryPriorityMappingEnabled = (
  user?: CategoryPriorityUser | null,
): boolean => {
  const directValue = user?.tenantSetting?.categoryPriorityMappingEnabled;

  if (typeof directValue === 'boolean') {
    return directValue;
  }

  return user?.parent?.tenantSetting?.categoryPriorityMappingEnabled === true;
};

export const getCategoryPrioritySelection = (
  priorityCode?: string | null,
): CategoryPrioritySelection | null => {
  const option = CATEGORY_PRIORITY_OPTIONS.find(({ value }) => value === priorityCode);

  if (!option) {
    return null;
  }

  return {
    priorityCode: option.value,
    priorityLabel: option.priorityLabel,
  };
};

export const getTicketCreationPriorityFields = (
  enabled: boolean,
  priority?: string | null,
): Record<string, never> | { priority: LegacyTicketPriority } => {
  if (enabled) {
    return {};
  }

  return { priority: (priority ?? '') as LegacyTicketPriority };
};
